export default __webpack_public_path__ + "static/media/Boneshadow Mask.c2fb6056.jpg";